import { SidebarPackageGb, SidebarRoaming } from "@nju/feature-portal-sidebar";
import { IOfferType, IPackageGb } from "../types";

interface ISidebarProps {
  isCountrySelected: boolean;
  isNotEnoughFunds: boolean;
  userFunds: number;
  price: number | undefined;
  offerType: IOfferType | undefined;
  packageGb: IPackageGb;
  voicePackageAnniversaryDate: number | undefined;
  dataPackageAnniversaryDate: number | undefined;
}

export function Sidebar({
  dataPackageAnniversaryDate,
  voicePackageAnniversaryDate,
  isCountrySelected,
  price,
  offerType,
  userFunds,
  isNotEnoughFunds,
  packageGb,
}: ISidebarProps) {
  const showRoamingSidebar = isCountrySelected && offerType !== "EU";
  const showPackageGbSidebar = isCountrySelected && offerType === "EU";

  if (showRoamingSidebar) {
    return (
      <SidebarRoaming
        dataPackageAnniversaryDate={dataPackageAnniversaryDate}
        hasNoFunds={isNotEnoughFunds}
        productOfferPrice={price || 0}
        userFunds={userFunds}
        voicePackageAnniversaryDate={voicePackageAnniversaryDate}
      />
    );
  }

  if (
    showPackageGbSidebar &&
    packageGb.anniversaryDate &&
    packageGb.productOfferGrantValue &&
    packageGb.productOfferPrice
  ) {
    return (
      <SidebarPackageGb
        anniversaryDate={packageGb.anniversaryDate}
        hasNoFunds={isNotEnoughFunds}
        productOfferGrantValue={packageGb.productOfferGrantValue}
        productOfferPrice={packageGb.productOfferPrice}
        userFunds={userFunds}
      />
    );
  }

  return <></>;
}
